import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { goToLogin } from '../nav/navigationService';

function LoginRequired(props) {
    useEffect(() => {
        if (!props.loggedIn) {
            goToLogin();
        }
    }, [props.loggedIn, goToLogin]);

    return props.children ?? <Outlet />;
}

LoginRequired.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    children: PropTypes.node,
};

export default connect((store) => ({
    loggedIn: store.auth.authentication.loggedIn,
}))(LoginRequired);
